/** Compute water level in mm from DDS45-LB sensor config and distance reading.
 *
 *  Formula: water_level = sensor_height - distance  (clamped to 0)
 *
 *  Returns null when any required value is missing.
 */
export function computeWaterLevel(
  distanceMm: number | null | undefined,
  sensorHeightMm: number | null | undefined
): number | null {
  if (distanceMm == null || sensorHeightMm == null) return null;
  return Math.max(0, sensorHeightMm - distanceMm);
}

/** Compute fill percentage from DDS45-LB sensor config and distance reading.
 *
 *  Formula: water_level = sensor_height - distance
 *           fill_pct    = (water_level / max_fill_height) * 100  (clamped 0–100)
 *
 *  Returns null when any required value is missing or max fill height is zero.
 */
export function computeFillPct(
  distanceMm: number | null | undefined,
  sensorHeightMm: number | null | undefined,
  maxFillHeightMm: number | null | undefined
): number | null {
  if (distanceMm == null || sensorHeightMm == null || maxFillHeightMm == null) return null;
  if (maxFillHeightMm <= 0) return null;
  const waterLevel = sensorHeightMm - distanceMm;
  const pct = (waterLevel / maxFillHeightMm) * 100;
  return Math.min(100, Math.max(0, pct));
}
